import axios from "axios";
import {Auth} from "aws-amplify";

const instance = axios.create({
    headers: {
        'content-type': 'application/json',
        accept: 'application/json'
    }
});

// Set the AUTH token for any request
instance.interceptors.request.use(async function (config) {
    let token = await Auth.currentSession();
    config.headers.Authorization = `Bearer ${token.getAccessToken().getJwtToken()}`;
    return config;
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if (error.response.data.name === "TokenExpiredError") {

    }
    return Promise.reject(error);
});

export default instance;